import { TypedDocumentNode, gql } from '@apollo/client';
import styled from 'styled-components';

import { LastOwnedCardsByPlayer } from 'components/player/LastOwnedCardsByPlayer';

import { BenchObjectTableFirstCell } from '../BenchObjectTable/ui';
import { AnyStatsIconCell } from './AnyStatsIconCell';
import { CommonPlayerMetas } from './CommonPlayerMetas';
import { BenchObjectPlayerCell_anyPlayer } from './__generated__/index.graphql';

type Props = {
  anyPlayer: BenchObjectPlayerCell_anyPlayer;
  onStatsClick: () => void;
};

const TopLeftPosition = styled.div`
  z-index: 10;
  position: absolute;
  top: var(--unit);
  left: var(--unit);
`;

export const BenchObjectPlayerCell = ({ anyPlayer, onStatsClick }: Props) => {
  return (
    <BenchObjectTableFirstCell>
      <TopLeftPosition>
        <LastOwnedCardsByPlayer anyPlayer={anyPlayer} />
      </TopLeftPosition>
      <CommonPlayerMetas anyPlayer={anyPlayer} onStatsClick={onStatsClick} />
      <AnyStatsIconCell anyPlayer={anyPlayer} onStatsClick={onStatsClick} />
    </BenchObjectTableFirstCell>
  );
};

BenchObjectPlayerCell.fragments = {
  anyPlayer: gql`
    fragment BenchObjectPlayerCell_anyPlayer on AnyPlayerInterface {
      slug
      ...CommonPlayerMetas_anyPlayer
      ...AnyStatsIconCell_anyPlayer
      ...LastOwnedCards_anyPlayer
    }
    ${CommonPlayerMetas.fragments.anyPlayer}
    ${AnyStatsIconCell.fragments.anyPlayer}
    ${LastOwnedCardsByPlayer.fragments.anyPlayer}
  ` as TypedDocumentNode<BenchObjectPlayerCell_anyPlayer>,
};
